var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","color":""}},[_c('v-img',{staticClass:"align-end",attrs:{"src":"http://47.94.10.11/static/files/bar.gif","height":"220"}},[_c('v-card-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.advtext))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }